import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./store";

// "ResizeObserver loop completed with undelivered notifications" is a benign
// browser notice (an observed element resized again in the same frame — the
// browser just defers the next delivery). It's harmless and invisible in
// production, but CRA's dev overlay surfaces it as a full-screen error.
// Swallow exactly this message so it can't interrupt manual testing.
window.addEventListener("error", (e) => {
  if (
    typeof e.message === "string" &&
    e.message.includes("ResizeObserver loop")
  ) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    ,
  </React.StrictMode>,
);
